export const GENERAL_SKILLS = {
  "关羽": [{ id: "assassinate", name: "🗡 青龙刺杀", note: "锁定最近敌方武将，重创其生命并打击军心" }],
  "张飞": [{ id: "assassinate", name: "🗡 猛将刺杀", note: "突袭最近敌方武将，重创其生命并打击军心" }],
  "赵云": [{ id: "assassinate", name: "🗡 七进七出", note: "锁定最近敌方武将，重创其生命并打击军心" }],
  "张辽": [{ id: "assassinate", name: "🗡 威震逍遥津", note: "锁定最近敌方武将，重创其生命并打击军心" }],
  "许褚": [{ id: "assassinate", name: "🗡 虎痴突袭", note: "突袭最近敌方武将，重创其生命并打击军心" }],
  "马超": [{ id: "assassinate", name: "🗡 铁骑突杀", note: "锁定最近敌方武将，重创其生命并打击军心" }],
  "甘宁": [{ id: "assassinate", name: "🗡 锦帆夜袭", note: "锁定最近敌方武将，重创其生命并打击军心" }],
  "太史慈": [{ id: "assassinate", name: "🗡 神亭突击", note: "锁定最近敌方武将，重创其生命并打击军心" }],
  "诸葛亮": [{ id: "wideAttack", name: "🔥 八阵火攻", note: "对指定军团周围敌军造成范围伤害并降低士气" }],
  "周瑜": [{ id: "wideAttack", name: "🔥 赤壁火海", note: "对指定军团周围敌军造成范围伤害并降低士气" }],
  "司马懿": [{ id: "wideAttack", name: "🔥 玄谋天火", note: "对指定军团周围敌军造成范围伤害并降低士气" }],
  "陆逊": [{ id: "wideAttack", name: "🔥 火烧连营", note: "对指定军团周围敌军造成范围伤害并降低士气" }],
  "黄月英": [{ id: "wideAttack", name: "🔥 连弩轰击", note: "对指定军团周围敌军造成范围伤害并降低士气" }],
};

export const ADDITIONAL_SKILLS = [
  ["march", "🏃 急行军", "军略", "行军速度提高，适合快速支援和追击。"], ["fortify", "🛡 坚壁", "军略", "驻守城池时降低受到的常规伤害。"],
  ["formation", "⚔ 雁行阵", "军略", "统军时提升远程部队的齐射稳定性。"], ["charge", "🐎 铁骑冲阵", "军略", "骑兵冲锋造成更高的首次冲击伤害。"],
  ["logistics", "🌾 粮道整饬", "军略", "降低出征粮草消耗，长途作战更持久。"], ["scout", "👁 斥候先行", "军略", "扩大视野并更早发现附近敌军。"],
  ["duel", "🗡 单骑挑战", "武勇", "近战时更容易压制敌方将领的军心。"], ["spearhead", "⚡ 破阵突击", "武勇", "对敌方坚守阵型的第一轮攻击更有效。"],
  ["archery", "🏹 百步穿杨", "武勇", "弓兵远程攻击的命中与伤害略有提升。"], ["guardian", "🦁 护军死士", "武勇", "所属军团溃散阈值提高，较不易崩溃。"],
  ["fire", "🔥 火计", "谋略", "火攻和营寨破坏效果增强。"], ["stratagem", "🎭 奇谋", "谋略", "战术成功率和对敌士气打击小幅提高。"],
  ["water", "🌊 水战", "谋略", "在河流和水乡地形作战时获得优势。"], ["heal", "🧪 医护", "谋略", "战后伤兵恢复与军团士气恢复更快。"],
  ["counterintelligence", "🕯 反间", "谋略", "降低敌方煽动和离间造成的影响。"], ["diplomacy", "🤝 外交", "政务", "外交、劝降和招揽行动更容易成功。"],
  ["governance", "🏮 治理", "政务", "任太守时提升城池收入与民心恢复。"], ["recruitment", "📣 招募", "政务", "城池募兵效率提高，补充兵力更快。"],
  ["inspiration", "🎺 鼓舞", "家眷", "提升所属军团的初始士气和士气恢复。"], ["charm", "🌸 倾城", "家眷", "婚配、安抚和家眷相关互动的魅力效果增强。"],
].map(([id, name, category, contribution]) => ({ id: `extra:${id}`, name, category, contribution, note: "可在技能管理页手动分配。" }));
